module.exports = __webpack_public_path__ + "img/Twitter.b2cda707.png";